// extracted by mini-css-extract-plugin
export default {"outerCon":"styles_outerCon__gZm3R","titleCon":"styles_titleCon__kEnM4","title":"styles_title__JNwWS","rtl":"styles_rtl__iQvKP","titleLink":"styles_titleLink__2GxDY"};